import styled from 'styled-components';
import { Colors, Shadows } from 'enums';
import { Icon } from 'view/atoms';

export const ProfileBox = styled.div<{ showModal: boolean }>`
  display: flex;
  align-items: center;
  cursor: pointer;
  background-color: ${({ showModal }) =>
    showModal ? Colors.background : 'transparent'};
  border-radius: ${({ showModal }) =>
    showModal ? '100px 30px 30px 100px' : '0'};

  & > :last-child {
    margin-left: 12px;
    margin-right: 12px;
  }

  &:hover {
    fill: black;
    background-color: ${Colors.background};
    border-radius: 100px 30px 30px 100px;
  }
`;

export const UpIcon = styled(Icon)`
  rotate: 180deg;
`;

export const ModalProfile = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  position: absolute;
  right: 80px;
  top: 84px;
  width: 360px;
  border-radius: 10px;
  padding: 20px;
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: ${Shadows.darkShadow};
`;

export const ContentName = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const APlayerPeriod = styled.div`
  display: flex;
  align-items: center;
  & > :first-child {
    margin-right: 8px;
  }
`;
